/* Breakpoint Tees — shop page interactions */
(function () {
  'use strict';

  /* ---------- Mobile filter panel toggle ---------- */
  var toggle = document.getElementById('filterToggle');
  var sidebar = document.getElementById('shopSidebar');
  if (toggle && sidebar) {
    toggle.addEventListener('click', function () {
      var open = sidebar.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Size selector ---------- */
  document.querySelectorAll('.size-box').forEach(function (box) {
    box.addEventListener('click', function () {
      box.classList.toggle('active');
    });
  });

  /* ---------- Price slider fill ---------- */
  var slider = document.querySelector('.price-slider');
  if (slider) {
    var paint = function () {
      var min = +slider.min || 0;
      var max = +slider.max || 100;
      var pct = ((slider.value - min) / (max - min)) * 100;
      slider.style.setProperty('--fill', pct + '%');
    };
    paint();
    slider.addEventListener('input', paint);
  }
})();
